import React from 'react'
import Modal from './Modal'

export default function () {
  return (
    <Modal/>
  )
}
